"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualInterestRateFormula = void 0;
exports.getAnnualInterestRate = getAnnualInterestRate;
const general_formulas_1 = require("./general-formulas"); /*
 * Enumeration of AnnualInterestRate formala implementation names
 */
var AnnualInterestRateFormula;
(function (AnnualInterestRateFormula) {
    AnnualInterestRateFormula[AnnualInterestRateFormula["DEFAULT"] = 0] = "DEFAULT";
})(AnnualInterestRateFormula || (exports.AnnualInterestRateFormula = AnnualInterestRateFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getAnnualInterestRate(formula) {
    switch (formula) {
        default:
            return default_annualInterestRate;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_annualInterestRate = (periodicRate, periodsPerYear) => {
    // ensure valid argument types
    if (typeof periodicRate === 'number' && typeof periodsPerYear === 'number') {
        return (0, general_formulas_1.toFixedNumber)(periodicRate * periodsPerYear, 2);
    }
    return NaN;
};
//# sourceMappingURL=annual-interest-rate-formula.js.map